<template>
  <div v-if="showModel" class="edit-model">
    <div class="img-div">
      <div>{{ title }}</div>
      <div class="close-img" @click="cancel">
        <i class="iconfont">&#xe641;</i>
      </div>
    </div>
    <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
      <FormItem label="试卷名" prop="title">
        <Input type="text" v-model="formData.title"></Input>
      </FormItem>
      <FormItem label="封面" prop="thumb" class="ivu-form-item-required">
        <ImgUpload
            ref="upLogoImg"
            :action="uploadUsersAvatar"
            :hasUpload="hasUpload"
            :num="1"
            @setThumbUrl="setThumbUrlthumb"
        ></ImgUpload>
      </FormItem>
      <FormItem label="所属分类" prop="belongs">
        <RadioGroup v-model="formData.belongs">
          <Radio v-for="item in belongs" :key="item.value" :label="`${item.value}`">
            <span>{{ item.label }}</span>
          </Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="试卷时长（分钟）" prop="time_range">
        <Input type="text" v-model="formData.time_range"></Input>
      </FormItem>
      <FormItem label="试卷时长（分钟）" prop="time_range">
        <Input type="text" v-model="formData.time_range"></Input>
      </FormItem>
      <FormItem label="是否可重复答题 " prop="is_repeat" class="ivu-form-item-required">
        <RadioGroup v-model="formData.is_repeat">
          <Radio label="1">
            <span>是</span>
          </Radio>
          <Radio label="2">
            <span>否</span>
          </Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="时间范围" prop="sort" class="ivu-form-item-required">
        <!-- <TimePicker v-model="formData.timeArea" format="HH:mm" type="timerange" placement="bottom" placeholder="请选择时间范围" style="width: 200px" @on-change="setSelected($event,'timeArea')"></TimePicker> -->
        <DatePicker format="yyyy-MM-dd HH:mm:ss" @on-change="setSelected($event,'timeArea')" type="daterange"
                    placement="bottom" v-model="formData.timeArea" placeholder="请选择时间范围"
                    style="width: 400px"></DatePicker>
      </FormItem>
      <FormItem label="试卷題数" prop="num">
        <Input type="text" v-model="formData.num"></Input>
      </FormItem>
      <FormItem label="状态 " prop="status" class="ivu-form-item-required">
        <RadioGroup v-model="formData.status">
          <Radio label="1">
            <span>正常</span>
          </Radio>
          <Radio label="2">
            <span>关闭</span>
          </Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="排序" prop="sort">
        <Input type="text" v-model="formData.sort"></Input>
      </FormItem>
      <FormItem>
        <Button :disabled="disabled" type="primary" @click="subData('formData')">确定</Button>
      </FormItem>
    </Form>
  </div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from "@/common/common";
import ImgUpload from "@/views/common/upload";
import SearchSelect from '@/views/common/selectList';
import moment from 'moment'

export default {
  props: {
    showModel: Boolean,
    fn: Function,
    type: Number,
    editFormData: Object,
    belongs: Array
  },
  name: "Model1",
  components: {
    ImgUpload,
    SearchSelect
  },

  data() {
    var Phone = function (rule, value, callback) {
      if (!value.match(/^1[0-9]{10}$/)) {
        return callback(new Error("请输入正确的手机格式"));
      } else {
        callback();
      }
    };
    return {
      title: "添加",
      disabled: false,
      searchSectionUrl: this.config.urlArray.getAllSection,
      uploadUsersAvatar: this.config.urlArray.commonUploadImage, //上传图片接口
      hasUpload: [], //已上传图片
      list: [],
      userList: [],
      defaultData: {
        id: "",
        title: "",
        thumb: "",
        time_range: "",
        is_repeat: "1",
        start_time: "",
        end_time: "",
        num: "",
        belongs: '10001',
        status: "1",
        sort: "100",
        timeArea: ['', '']
      },
      formData: {},
      ruleCustom: {
        //验证
        title: [
          {required: true, message: "试卷名必须填写", trigger: "blur"},
        ],
        belongs: [
          {required: true, message: '请选择所属分类'}
        ],
        thumb: [
          {required: true, message: "thumb必须填写", trigger: "blur"},
        ],
        time_range: [
          {required: true, message: "试卷时长必须填写", trigger: "blur"},
        ],
        num: [
          {required: true, message: "试卷題数必须填写", trigger: "blur"},
        ],
        sort: [
          {required: true, message: "排序必须填写", trigger: "blur"},
        ],
      }
    };
  },
  watch: {
    showModel(val) {
      if (val) {
        if (this.type && this.type == 2) {
          this.title = "编辑";
          this.editForm();
        }
        if (this.type && this.type == 1) {

          this.title = "添加";
          this.formData = this.defaultData;
          this.formData.timeArea[0] = moment().format("YYYY-MM-DD HH:mm:ss"); //当前时间
        }
      }
    }
  },
  methods: {
    setSelected(data, key) {
      this.formData[key] = data;
    },
    editForm() {
      for (let key in this.defaultData) {
        this.formData[key] =
            this.editFormData[key] instanceof Array ||
            this.editFormData[key] instanceof Object
                ? this.editFormData[key]
                : String(this.editFormData[key]);
        if (!this.editFormData[key]) {
          this.formData[key] = "";
        }
      }

      this.formData.timeArea = [this.formData.start_time, this.formData.end_time]
      this.$nextTick(() => {
        let hasUpload = [
          {
            status: "finished",
            response: {data: this.formData.thumb}
          }
        ];
        this.$refs.upLogoImg.setHasUpload(hasUpload); //为上传组件付默认值
      });
    },
    setThumbUrlthumb(url) {
      this.formData.thumb = url;
    },
    subData(name) {
      //提交表单
      this.$refs[name].validate(valid => {
        if (valid) {
          this.disabled = true;
          this.formData.start_time = this.formData.timeArea[0]
          this.formData.end_time = this.formData.timeArea[1]
          this.axios
              .post(this.config.urlArray.examStore, this.formData)
              .then(result => {
                common.ajaxMsg(
                    result.data,
                    true,
                    () => {
                      //提交表单后的回调处理
                      this.resetForm(); //重置表单
                      this.fn();
                    },
                    () => {
                      this.disabled = false;
                    }
                );
              })
              .catch(err => {
                common.msg("error", "提交失败", () => {
                  this.disabled = false;
                });
              });
        }
      });
    },
    setSelectVal(data, key) {
      this.formData[key] = data.join(',')
    },
    cancel() {
      //对话框关闭
      this.$emit("update:showModel", false);
      this.fn();
    },
    setThumbUrl(url) {
      //获取图片上传后的路径
      this.formData.thumb = url;
    },
    resetForm() {
      //重置表单
      this.formData = this.defaultData
      this.timeArea = ['', '']
      this.formData.id = '';
      this.$refs.formData.resetFields(); //重置表单
      this.disabled = false; //恢复提交按钮为激活状态
    }
  }
};
</script>
<style lang='scss' scoped>
.edit-model {
  position: relative;

  .img-div {
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 45px;

    div {
      font-weight: bold;
      font-size: 15px;
    }
  }

  .close-img {
    border: 1px solid #fd6363;
    display: inline-block;
    line-height: 100%;
    border-radius: 100%;
    padding: 5px;
    color: #f00;
    right: 10px;
    top: 10px;
    z-index: 3;
    cursor: pointer;
  }

  .close-img:hover {
    transform: scale(1.1);
    transition: all 0.3s;
  }
}

.form-div {
  display: flex;

  .right-ss {
    padding-left: 20px;
    box-sizing: border-box;
    flex: 1;
    word-break: break-all;
    min-width: 300px;

    .list {
      max-height: 500px;
      overflow-y: auto;

      .item {
        margin: 10px 0px;
        border-bottom: 1px dashed #ccc;

        p {
          display: flex;

          span:nth-of-type(1) {
            font-weight: bold;
            margin-right: 4px;
            width: 60px;
            display: inline-block;
          }

          span:nth-of-type(2) {
            flex: 1;
            font-size: 12px;
          }
        }
      }

      .activeP {
        background: linear-gradient(to bottom, #25cbae 0%, #cdfff5 100%);
      }
    }
  }
}
</style>
